import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axiosClient from 'helpers/axiosClient';
import { TYPE_NOTIFI } from 'hooks/types';
import _, { merge } from 'lodash';
import { Moment } from 'moment';

export interface Manager {
  id: number;
  name: string;
}
export interface Notifi {
  id: number;
  managerId: number;
  title: string;
  body: string;
  data: {
    objectId: number;
    [key: string]: number | boolean | string | null;
  };
  type: TYPE_NOTIFI;
  readAt: Moment | null;
  createdAt: Moment;
  updatedAt: Moment;
}

export type NotifiState = {
  params?: {
    getTotalUnRead?: boolean;
    limit?: number;
    page?: number;
  };
  loading?: boolean;
  total?: number;
  totalUnRead?: number;
  items?: Notifi[];
};

const initialState: NotifiState = {
  params: {
    ...axiosClient.paging,
    getTotalUnRead: true
  },
  loading: false,
  total: 0,
  totalUnRead: 0,
  items: []
};

const listNotifi = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    changeNotifi: (state: NotifiState, action: PayloadAction<NotifiState>) => {
      state = _.merge(state, action.payload);
    },
    changeLoading: (state: NotifiState, action: PayloadAction<NotifiState['loading']>) => {
      state.loading = action.payload;
    },
    changeParams: (state: NotifiState, action: PayloadAction<NotifiState['params']>) => {
      state.params = merge(state.params, action.payload);
    }
  }
});

const { reducer, actions } = listNotifi;
export const { changeNotifi, changeLoading, changeParams } = actions;
export default reducer;
